/**
 * 按设计稿宽度动态设置 html 根字号，实现小屏 rem 等比缩放。
 * 设计宽度 1920、基准字号 14px（与全局样式一致）；≥1920 锁定不放大，
 * 下限约 10px，对应可视宽度约 1366，避免更窄时布局尺寸过小。
 *
 * 正文字号下限 12px。普通 CSS：font-size: max(12PX, Nrem);
 * Less 中需转义：font-size: ~"max(12PX, Nrem)";（避免 Less 求值 max）
 */
const BASE_SIZE = 14;
const DESIGN_WIDTH = 1920;
const MIN_SIZE = 10;
/** 业务 font-size 像素下限 */
export const MIN_FONT_SIZE_PX = 12;

/**
 * 根据当前视口宽度写入 documentElement.fontSize。
 */
function setRem() {
  const docEl = document.documentElement;
  const clientWidth = docEl.clientWidth || window.innerWidth || DESIGN_WIDTH;
  const width = Math.min(clientWidth, DESIGN_WIDTH);
  const fontSize = Math.max(MIN_SIZE, (width / DESIGN_WIDTH) * BASE_SIZE);
  docEl.style.fontSize = `${fontSize}px`;
}

/**
 * 初始化 rem：立即计算一次，并在 resize / pageshow 时重算。
 */
export function initRem() {
  setRem();
  window.addEventListener("resize", setRem);
  // bfcache 返回页面时重新校准根字号
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      setRem();
    }
  });
}

export default setRem;
